import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { WebinarpageService } from '../../webinarpage.service';
import { CommonModule } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-webinars-article-podcasts',
  templateUrl: './webinars-article-podcasts.component.html',
  styleUrls: ['./webinars-article-podcasts.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
})
export class WebinarsArticlePodcastsComponent implements OnInit, OnDestroy {
  @Input() pageData: any;
  @ViewChild('registerLink') registerLink: any;
  queryParams: any;
  subscriptions: Subscription[];
  cards: any;

  constructor(
    private webinarPageService: WebinarpageService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  ngOnInit(): void {
    
  }
  ngOnChanges(): void {
    let data = this.pageData?.fields;
    if (data != null) {
      this.cards = data?.webinarAndPodcastsElements;
    }
  }
  openWebinarLink(event:any, target?:string) {
    event.preventDefault();
    const link = event.target.attributes.href.value;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, target || '_self');
  }
}
